import React from 'react';
import { Card, Row, Col, Table } from 'react-bootstrap';

/**
 * Componente para renderizar dados de tabela em formato de cards em telas pequenas.
 * Em telas maiores, renderiza a tabela padrão.
 * 
 * @param {object} props
 * @param {Array<object>} props.data - Array de objetos com os dados a serem exibidos.
 * @param {Array<object>} props.columns - Array de objetos definindo as colunas.
 * @param {string} props.columns[].key - Chave do objeto de dados para a coluna.
 * @param {string} props.columns[].header - Título da coluna.
 * @param {function} [props.columns[].render] - Função opcional para renderizar o conteúdo da célula.
 * @param {string} [props.columns[].className] - Classe CSS opcional para a célula.
 * @param {string} [props.keyField='id'] - Campo a ser usado como chave única para a renderização.
 * @param {string} [props.cardTitleKey] - Chave do objeto de dados para usar como título do card.
 * @param {React.ReactNode} [props.actions] - Componente com as ações a serem exibidas no card.
 */
const CardViewTable = ({ data, columns, keyField = 'id', cardTitleKey, actions }) => {
  // Renderização em formato de Cards para mobile (sm e abaixo)
  const renderCards = () => (
    <div className="d-block d-md-none">
      {data.map((item, index) => (
        <Card key={item[keyField] || index} className="mb-3 shadow-sm">
          <Card.Body>
            {cardTitleKey && <Card.Title className="mb-3">{item[cardTitleKey]}</Card.Title>}
            <Row>
              {columns.map((col) => {
                // Ignora colunas de Ações na visualização de detalhes do card
                if (col.key === 'actions') return null;

                const value = col.render ? col.render(item) : item[col.key];
                const header = col.header;

                return (
                  <Col xs={12} className="mb-2" key={col.key}>
                    <strong className="d-inline-block me-2">{header}:</strong>
                    <span className={col.className}>{value}</span>
                  </Col>
                );
              })}
            </Row>
            {/* Renderiza as ações no final do card */}
            {actions && <div className="mt-3 border-top pt-3">{actions(item)}</div>}
          </Card.Body>
        </Card>
      ))}
    </div>
  );

  // Renderização em formato de Tabela padrão para desktop (md e acima)
  const renderTable = () => (
    <div className="d-none d-md-block">
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key}>{col.header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={item[keyField] || index}>
              {columns.map((col) => (
                <td key={col.key} className={col.className}>
                  {col.key === 'actions' ? actions(item) : (col.render ? col.render(item) : item[col.key])}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );

  return (
    <>
      {renderCards()}
      {renderTable()}
    </>
  );
};

export default CardViewTable;
